<template>
  <div>
    <div style>
      <p style="text-align: center;">Carriage of goods agreement</p>
      <p style="margin-bottom:10px">更新发布时间：2021年11月12日</p>
      <p style="margin-bottom:10px">Update: November 12, 2021</p>
      <p>本协议由您与航迅（深圳）网络科技有限公司共同缔结，本协议具有合同效力。本协议中航迅（深圳）网络科技有限公司称为航迅。</p>
      <p>
        This agreement is entered into by you and hangxun (Shenzhen) Network
        Technology Co., Ltd. This agreement has the effect of contract. hangxun
        (Shenzhen) Network Technology Co., Ltd. is referred to as hangxun in this
        agreement. 1. 协议生效Agreement comes into effect
      </p>
      <p>
        1.1.您应该在与航迅签署协议之前仔细阅读全部协议内容，只要您在线同意本协议，即视为您已仔细阅读协议全部内容，本协议即在您和航迅之间产生法律效力，届时您不应以未阅读本协议的内容为理由，主张本协议无效或要求撤销本协议。
        You should read it carefully before signing the agreement with hangxun all
        agreements, as long as you agree to this agreement online, that as you
        have read the agreement carefully the whole content, this agreement is
        between you and hangxun produced legal effectiveness, then you should not
        be on the grounds of not reading the content of this agreement, this
        agreement is invalid or ask for the cancellation of this agreement.
      </p>
      <p>1.2.您承诺接受并遵守本协议的商定。假如您不同意本协议的商定，点击不同意退出本次服务。</p>
      <p>
        You undertake to accept and abide by the agreement. If you do not agree
        with the agreement, Click disagree to exit the service.
      </p>
      <p>
        1.3航迅有权依据实际状况时常调整本协议和相关规章的内容，更改版本内容在本页面发布，请点击本服务条款时仔细阅读；服务条款及不时修订内容或更新版本内容自发布之日生效。
        hangxun reserves the right to adjust the content of this Agreement and
        relevant regulations from time to time according to the actual
        situation. The Terms of Service and the contents amended or updated from
        time to time shall take effect as of the date of publication.
      </p>
      <p>
        2.
        为符合法律法规对货物运输安全的要求，保证货物运输安全送达，您在寄件时应履行以下义务。
      </p>
      <p>
        In order to meet the requirements of laws and regulations on the safety
        of cargo transportation and ensure the safe delivery of cargo
        transportation, you shall perform the following obligations when sending
        the cargo.
      </p>
      <p>2.1.确保货物不包含国家机关公文、国家保护野生动物及制品、假冒伪劣和侵权物品等法律法规禁止和限制运输物品，不得通过运输渠道危害国家安全、公共安全；不得运输国家法律法规明令禁止出口和目的国明令禁止进口物品。</p>
      <p>
        To ensure that goods do not contain official documents of state organs,
        wildlife and products under state protection, fake and shoddy goods and
        infringing goods prohibited or restricted by laws and regulations, and
        shall not endanger national security and public security through
        transportation channels; It is prohibited to transport articles whose
        export is prohibited by national laws and regulations and whose import
        is prohibited by the destination country.
      </p>
      <p>2.2.如实申报货物的品名、属性、数量和价值，并准确填写寄件人、收件人的名称、地址、联系电话等信息。</p>
      <p>
        Truthfully declare the name, attribute, quantity and value of the goods,
        and accurately fill in the name, address, contact telephone number and
        other information of senders and receivers.
      </p>
      <p>
        2.3.配合进行开箱验视,航迅有权对收取货物进行开箱验视和拍照取证，确保运输货物不违反国家法律法规禁运要求，如发现违反国家法律法规的物品，有权移交到相关部门处理。
        Cooperate with the unpacking inspection, hangxun has the right to unpacking
        inspection and take photos of the received goods to ensure that the
        goods do not violate the embargo requirements of national laws and
        regulations, if found in violation of national laws and regulations,
        have the right to transfer to the relevant departments.
      </p>
      <p>
        3.
        因运输货物属于或含有禁止或限制运输物品而被查没，扣留、空仓、罚款等，给航迅或第三方造成经济损失的，您应承担赔偿责任。
        If the transported goods are or contain prohibited or restricted items
        and are confiscated, detained, empty warehouses, fines, etc., which
        cause economic losses to hangxun or a third party, you shall be liable for
        compensation.
      </p>
      <p>
        4.
        因违禁品引发的安全事故，承担经济赔偿的同时依照国家法律法规还需要承担相应的法律责任。
        In case of safety accidents caused by contraband goods, economic
        compensation shall be borne while corresponding legal liabilities shall
        be borne in accordance with national laws and regulations.
      </p>
      <p>5.关于货物理赔方案About the cargo claim scheme</p>
      <p>5.1. 保丢不保损 Pay for lost, but not for damaged</p>
      <p>5.1.1.货物运输途中外箱或内物破损造成的损失，航迅不予赔偿。</p>
      <p>
        hangxun will not compensate for any damage caused by damage to the outer
        container or contents of the goods during transit.
      </p>
      <p>5.1.2.航迅对货物部分丢失、全部丢失给予赔偿，依据货物价值双方协商处理，最高赔偿运费两倍（含已付运费），增值服务产生的费用不予赔偿。</p>
      <p>
        hangxun will pay compensation for partial or total loss of goods, which
        shall be handled by both parties through negotiation based on the value
        of goods. The maximum compensation is twice the freight (including the
        paid freight). No compensation will be paid for the cost of value-added
        services.
      </p>
      <p>5.2. 延误赔偿说明 Explanation of compensation for Delay</p>
      <p>5.2.1. 因时效延误产生的损失，航迅不承担任何赔偿。</p>
      <p>
        hangxun shall not be liable for any damages arising from the delay of
        limitation.
      </p>
      <p>5.3. 免责说明 Disclaimer</p>
      <p>
        5.3.1.
        因台风、地震、洪灾、暴风雪、海啸、泥石流、战争、暴乱、疫情、政府管制等不可抗力导致的货物灭失、短少的情况。
      </p>
      <p>
        Loss or shortage of goods caused by force majeure such as typhoon,
        earthquake, flood, snowstorm, tsunami, mud-rock flow, war, riot,
        epidemic disease, government control, etc.
      </p>

      <p>5.3.2.其它法律法规或者双方约定航迅免于赔偿的。</p>
      <p>
        Other laws and regulations or mutual agreement exempting hangxun from
        compensation.
      </p>
      <p>6. 货物测量和检查 Goods survey and inspection</p>
      <p>6.1.航迅将按照货物实际重量和体积重量中较高者计算基础运费，实际计算费用以报价表为准。</p>
      <p>
        hangxun will calculate the base freight based on the higher of the actual
        weight and volume weight of the goods，the actual calculated expenses
        shall be subject to the quotation.
      </p>
      <p>6.2.在货物到达仓库后或签收前，航迅可以对任何一件货物重新称重和测量，以确认其计算数据。</p>
      <p>
        hangxun can re-weigh and measure any item after it arrives at the warehouse
        or before it is signed for collection to confirm its calculated data.
      </p>

      <p>7. 留置权Line</p>
      <p>若您或您指定的付款人未付清费用的，航迅有权留置货物，留置后您的债务履行期限为2个月（货物到达之日起计算），但货物不能留置的除外。债务履行期限届满，您或指定付款人仍未付清费用的，航迅可以变卖、拍卖留置物品优先受偿。变卖、拍卖所得价款应优先支付航迅为行使留置权所支出的费用和保管费，再偿付拖欠航迅的费用；如有余额，可根据您的要求汇至您指定账户。</p>
      <p>
        If you or your designated payer fail to pay the payment, hangxun has the
        right to place a lien on the goods. After the lien, your debt
        performance period will be 2 months (counting from the date of arrival
        of the goods), unless the goods cannot be placed on lien. If you or the
        designated payer still fail to pay the debt at the expiration of the
        debt performance period, hangxun may sell and auction the lien items to be
        paid first. The proceeds from sale and auction shall give priority to
        paying hangxun's expenses and storage fees for exercising the lien, and
        then reimburse hangxun's arrears. Balance, if any, can be remitted to your
        designated account upon your request.
      </p>
      <p>8. 货物销毁The goods destroyed</p>
      <p>若您对货物声明放弃、销毁，出具货物相关放弃、销毁证明，您不可就该货物再向航迅主张任何权利，航迅不再对此承担任何责任。</p>
      <p>
        If you declare abandonment and destruction of the goods, and issue
        relevant abandonment and destruction certificates of the goods, you
        cannot claim any rights against hangxun on the goods, and hangxun will no
        longer assume any responsibility for this.
      </p>
      <p>
        9.
        如果本条款中的某条款被法院或政府机构认定为无效或部分无效，则双方同意除无效条款外仍应执行本合同其它条款、部分有效条款在其可执行的范围内仍继续执行。
      </p>
      <p>
        If any provision of this article is held to be invalid or partially
        invalid by a court or government agency, both parties agree that except
        the invalid provision, other provisions of this Contract shall be
        executed and some valid provisions shall be executed to the extent that
        they are enforceable.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  methods: {},
};
</script>


// WEBPACK FOOTER //
// src/components/NewOrder/textInfo.vue